import * as React from "react";
import pluginRegistry, {ActionEditProps} from "../pluginRegistry";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import Roles from "../Roles";
import {ActionSummaryProps} from "../actionSummaryProps";
import {ActionExecutionLocation} from "../../../client/resources/actionExecutionLocation";
import FormSectionHeading from "components/form/Sections/FormSectionHeading";
import AzurePowerShellScriptInfo from "components/Actions/azurePowerShell/AzurePowerShellScriptInfo";
import WarningFormSection from "components/form/Sections/WarningFormSection";
import AzureServiceFabricSdkRequiredInfo from "components/Actions/azureServiceFabricApp/AzureServiceFabricSdkRequiredInfo";
import AzureServiceFabricAccountSelector, {AzureServiceFabricAccountSelectorProperties} from "components/Actions/azureServiceFabricApp/AzureServiceFabricAccountSelector";
import {ScriptActionEdit, ScriptProperties} from "components/Actions/script/scriptAction";
import { TargetRoles } from "areas/projects/components/DeploymentProcess/ActionDetails";

class AzureServiceFabricPowerShellSummary extends BaseComponent<ActionSummaryProps, any> {
    render() {
        return <div>
            Run a PowerShell script using an Azure Service Fabric cluster context
            {this.props.targetRolesAsCSV && <span> on behalf of targets in <Roles rolesAsCSV={this.props.targetRolesAsCSV}/></span>}
        </div>;
    }
}

interface AzureServiceFabricPowerShellProperties extends AzureServiceFabricAccountSelectorProperties, ScriptProperties {
}

interface AzureServiceFabricPowerShellState {
    resetValues: {
        ClientCertVariable: string;
    };
}

class AzureServiceFabricPowerShellActionEdit extends BaseComponent<ActionEditProps<AzureServiceFabricPowerShellProperties>, AzureServiceFabricPowerShellState> {
    constructor(props: any) {
        super(props);

        this.state = {
            resetValues: {
                ClientCertVariable: props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]
            }
        };
    }

    componentDidMount() {
        const properties: any = {};
        if (!this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"]) {
            properties["Octopus.Action.ServiceFabric.SecurityMode"] = "Unsecure";
        }
        if (!this.props.properties["Octopus.Action.ServiceFabric.AadCredentialType"]) {
            properties["Octopus.Action.ServiceFabric.AadCredentialType"] = "UserCredential";
        }
        this.props.setProperties(properties, true);
    }

    render() {
        const properties = this.props.properties;

        return <div>
            <WarningFormSection>
                <AzureServiceFabricSdkRequiredInfo />
                <AzurePowerShellScriptInfo actionType={this.props.plugin.actionType}/>
            </WarningFormSection>

            <FormSectionHeading title="Service Fabric Cluster"/>

            <AzureServiceFabricAccountSelector
                projectId={this.props.projectId}
                localNames={this.props.localNames}
                properties={this.props.properties}
                clientCertVariableResetValue={this.state.resetValues.ClientCertVariable}
                setProperties={this.props.setProperties}
                getFieldError={this.props.getFieldError}
                doBusyTask={this.props.doBusyTask}/>

            <ScriptActionEdit
                plugin={this.props.plugin}
                projectId={this.props.projectId}
                localNames={this.props.localNames}
                properties={this.props.properties}
                setProperties={this.props.setProperties}
                doBusyTask={this.props.doBusyTask}
                getFieldError={this.props.getFieldError}
                powerShellOnly={true}
                errors={this.props.errors}/>
        </div>;
    }
}

pluginRegistry.registerDeploymentAction({
    executionLocation: ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureServiceFabricPowerShell",
    summary: (properties, targetRolesAsCSV) => <AzureServiceFabricPowerShellSummary properties={properties} targetRolesAsCSV={targetRolesAsCSV} />,
    edit: AzureServiceFabricPowerShellActionEdit,
    canHaveChildren: (step) => true,
    canBeChild: true,
    hasPackages: (action) => false,
    targetRoleOption: TargetRoles.Optional
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/azureServiceFabricPowerShell/azureServiceFabricPowerShellAction.tsx